import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=9c7125bc&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=9c7125bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7125bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c7125bc')) {
      api.createRecord('9c7125bc', component.options)
    } else {
      api.reload('9c7125bc', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=9c7125bc&scoped=true&", function () {
      api.rerender('9c7125bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/performanceCalculation/views/result_statement/terminal_performance_target_report/form/detail.vue"
export default component.exports